/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Navigate } from 'react-router-dom';

import { LoadingSpinnerFullPage } from '@/components/LoadingSpinnerFullPage';
import { useUserProfileQuery } from '@/hooks/query/useUserProfileQuery';
import { selectedTenantIDKey, useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export type CallbackRouteProps = {
  replace?: boolean;
};

export function CallbackRoute({ replace }: CallbackRouteProps) {
  const { isLoading, data } = useUserProfileQuery({ refetchOnWindowFocus: false });
  const setProfile = useMgmtPlaneStateStore((state) => state.setProfile);

  if (isLoading) return <LoadingSpinnerFullPage />;

  const returnTo = sessionStorage.getItem('returnTo');
  const to = returnTo === '/' ? undefined : returnTo;
  if (to) {
    return <Navigate to={to} replace={replace} />;
  }

  const userProfile = data?.data;
  if (userProfile) {
    setProfile(userProfile);
    let { tenantID } = userProfile;
    if (userProfile.role === 'superadmin') {
      tenantID = localStorage.getItem(selectedTenantIDKey) || tenantID;
    }
    return <Navigate to={`/tenants/${tenantID}/activity`} replace={replace} />;
  }

  return <Navigate to="/login" replace />;
}
